import * as actionType from './ActionType';

export const changeProgress = (currentStep, totalStep) => ({
  type: actionType.CHANGE_PROGRESS,
  payload: {
    step: currentStep,
    totalStep: totalStep,
    valueProgress: Math.ceil((currentStep ? (currentStep > 0 ? currentStep : 1) : 1 * 100) / totalStep)
  }
});

export const nextStep = (step) => ({
  type: actionType.NEXT_STEP,
  payload: { step }
});

export const prevStep = () => ({
  type: actionType.PREV_STEP
});
